export default __webpack_public_path__ + "static/media/PlanExpired.bd005776.svg";